var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.625,
    fill: "#1E1C56",
    stroke: "white",
    strokeWidth: 0.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.606 16.0813L24 19.4913V12.5273L18.606 16.0813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5273V19.4913L13.394 16.0813L8 12.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0003 10.5H9.00027C8.50127 10.5 8.10527 10.872 8.03027 11.351L16.0003 16.602L23.9703 11.351C23.8953 10.872 23.4993 10.5 23.0003 10.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6897 16.6861L16.2747 17.6181C16.1907 17.6731 16.0957 17.7001 15.9997 17.7001C15.9037 17.7001 15.8087 17.6731 15.7247 17.6181L14.3097 16.6851L8.03174 20.6561C8.10874 21.1311 8.50274 21.5001 8.99974 21.5001H22.9997C23.4967 21.5001 23.8907 21.1311 23.9677 20.6561L17.6897 16.6861Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/IconEmail.63068bff15559661bf2ad9d7613e574f.svg";
export { ForwardRef as ReactComponent };